import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@americanexpress/gravity-core';

const Overlay = (props) => {
  const {
    show, onClose, modalContent, modalDisclaimer, modalFooter,
    title, onKeyDown, onBack, queryParams, currentScreenId,
    data,
  } = props;
  if (!show) return null;
  return (
    <div id="settingsOverlay" data-toggle="dismissible">
      <div className="modal-screen safekey-modal-screen" />
      <div className="modal flex flex-align-center">
        <div className="container safekey-container" role="dialog" aria-labelledby="overlayTitle" aria-modal="true">
          <header aria-labelledby="overlayTitle" aria-describedby="overlayTitle" className="flex flex-align-center dls-bright-blue-bg dls-white safekey-modal-header">
            { onBack
            && (
              <Button
                id="onBack"
                className="safekey-back-icon focus-light"
                role="button"
                aria-label={data?.backBtn?.aria || 'Back'}
                onKeyDown={onKeyDown}
                onClick={onBack}
                identifier="axp-gravity-header"
                element="onBack"
                detail="backIcon"
                acsTransId={queryParams.acsTransId}
                screenId={currentScreenId}
                autoFocus={true}
              >
                <span className="glyph dls-glyph-left glyph-lg" aria-hidden="true" />
              </Button>
            )}
            <div role="heading" aria-level="2" className="fluid text-align-center safekey-modal-title" id="overlayTitle">{title}</div>
            { onClose
            && (
              <Button
                className="glyph dls-glyph-close glyph-lg focus-light"
                data-dismiss={true}
                onClick={onClose}
                aria-label={data?.closeBtn?.aria || 'Close'}
                data-testid="XBtn"
                id="settingsXIcon"
                identifier="axp-gravity-header"
                element="settingsXIcon"
                detail="closeIcon"
                acsTransId={queryParams.acsTransId}
                screenId={currentScreenId}
              />
            )}
          </header>
          <div className="card">
            {modalContent}
            <div>{modalDisclaimer}</div>
            <div className="border-t safekey-btn-padding-sm flex width-full">
              {modalFooter}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Overlay.propTypes = {
  show: PropTypes.bool.isRequired,
  modalContent: PropTypes.node.isRequired,
  modalDisclaimer: PropTypes.node,
  modalFooter: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  onKeyDown: PropTypes.oneOfType.isRequired,
  queryParams: PropTypes.shape({
    acsTransId: PropTypes.string.isRequired,
  }).isRequired,
  currentScreenId: PropTypes.string.isRequired,
  data: PropTypes.shape({
    backBtn: PropTypes.shape({
      aria: PropTypes.string,
    }),
    closeBtn: PropTypes.shape({
      aria: PropTypes.string,
    }),
  }),
};

Overlay.defaultProps = {
  modalDisclaimer: null,
};

export default Overlay;
